import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetUserId } from '@core/utils';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/entities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkShiftService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;
  private readonly _userId = GetUserId();

  find(pagination: Pagination) {
    return this._http.get(`${this._apiUrl}/getEventDataHaveShift/${pagination.page}/${pagination.pageSize}`);
  }

  get(id: number) {
    return this._http.get(`${this._apiUrl}/get-shift-by-event-id/${id}`).pipe(map((response: any) => response.result[0]));
  }

  create(formData: FormData) {
    return this._http.post(`${this._apiUrl}/createShift`, formData);
  }

  update(formData: FormData, id: number) {
    return this._http.put(`${this._apiUrl}/shift/${id}`, formData);
  }

  delete(id: number) {
    return this._http.delete(`${this._apiUrl}/shift/${id}`);
  }

  deleteAll(id: number) {
    return this._http.delete(`${this._apiUrl}/allshift/${id}`);
  }

  getEventsWithoutShifts(userId: number, id?: number) {
    const url = id ? `${this._apiUrl}/geteventWithoutShift/user/${userId}?eventId=${id}` : `${this._apiUrl}/geteventWithoutShift/user/${userId}`;
    return this._http.get(url);
  }

  downloadDocument(data: any) {
    return this._http.post(`${this._apiUrl}/download-shift-document`, data, { responseType: 'blob' });
  }
}
